import { FC, memo } from 'react';
import { ToastContainer } from 'react-toastify';

import { OButton } from '@src/shared';
import WebinarOverview from '../WebinarOverview';
import useWebinarRegistrationStatus from './useWebinarRegistrationStatus';

import { formatDateWithGmt } from '@src/utils';

import styles from './webinarRegistrationStatus.module.scss';
export interface IWebinarRegistrationProps {
  status: 'success' | 'alreadyRegistered' | 'declineInvitation';
}

const WebinarRegistrationStatus: FC<IWebinarRegistrationProps> = ({ status }) => {
  const { statusData: registrationStatus, roomData } = useWebinarRegistrationStatus();
  const currentRegistrationStatus = registrationStatus[status];

  return (
    <div className={styles.webinarRegistrationStatusContainer}>
      <WebinarOverview {...currentRegistrationStatus} />
      <div className={styles.registrationInfoContainer}>
        <div className={styles.registrationInfo}>
          <div className={styles.registrationInfoContent}>
            <span className={styles.registrationInfoLabel}>Topic</span>
            <span className={styles.registrationInfoLabel}>Time</span>
          </div>

          <div className={styles.registrationInfoContent}>
            <span className={styles.registrationInfoValue}>{roomData?.roomTitle}</span>
            <span className={styles.registrationInfoValue}>
              {roomData?.startTime ? formatDateWithGmt(roomData?.startTime) : ''}
            </span>
          </div>
        </div>
      </div>
      {currentRegistrationStatus.button && (
        <div>
          <OButton
            text={currentRegistrationStatus.button.text}
            variant={currentRegistrationStatus.button.variant}
            onClick={currentRegistrationStatus.button.onClick}
            disabled={currentRegistrationStatus.button.disabled}
            size="medium"
          />
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3500} />
    </div>
  );
};

export default memo(WebinarRegistrationStatus);
